// Drives the full-screen splash: Landing renders nothing while this is true
// (see component/app/landing/index.js), so only code that means "cover the app"
// should set it. LOGOUT deliberately does not — authLoginRequest dispatches
// logout() before login() purely to clear stale state, and when it is used to
// validate a password (right-toolbar/profile/edit/edit-password.js) that would
// blank the running app with no path back. Screens that need the splash on
// logout call setLoading themselves; Login does so on mount and update.
export default (state = true, { type, payload }) => {
  switch (type) {
    case 'LOADING':
      return payload
    default:
      return state
  }
}
